/** Express-Invoice-style workflow map on Billing Home. Coordinates are in px on a 600 × 460 canvas. */
export type FlowAction =
  | 'newQuote' | 'quotesList' | 'cashSale' | 'newInvoice' | 'refunds' | 'customers'
  | 'invoicesList' | 'newCreditNote' | 'creditNotesList' | 'applyPayment'
  | 'unpaidReport' | 'salesReport' | 'statements'

export type FlowTile = { id: FlowAction; label: string; x: number; y: number; w: number; h: number; tone: 'action' | 'highlight' | 'list' | 'report' }

export const flowTiles: FlowTile[] = [
  { id: 'customers', label: 'Customers List', x: 250, y: 0, w: 90, h: 90, tone: 'highlight' },
  { id: 'newQuote', label: 'New Quote', x: 0, y: 120, w: 90, h: 90, tone: 'action' },
  { id: 'quotesList', label: 'Quotes List', x: 0, y: 240, w: 90, h: 90, tone: 'list' },
  { id: 'cashSale', label: 'Non-Invoiced Cash Sale', x: 0, y: 358, w: 90, h: 90, tone: 'action' },
  { id: 'newInvoice', label: 'New Invoice', x: 120, y: 120, w: 100, h: 210, tone: 'action' },
  { id: 'refunds', label: 'Refunds and Returns', x: 120, y: 358, w: 100, h: 90, tone: 'action' },
  { id: 'invoicesList', label: 'Invoices List', x: 250, y: 240, w: 90, h: 90, tone: 'action' },
  { id: 'newCreditNote', label: 'New Credit Note', x: 250, y: 358, w: 90, h: 90, tone: 'action' },
  { id: 'applyPayment', label: 'Apply Payment', x: 370, y: 120, w: 100, h: 210, tone: 'action' },
  { id: 'creditNotesList', label: 'Credit Notes List', x: 370, y: 358, w: 100, h: 90, tone: 'list' },
  { id: 'unpaidReport', label: 'Unpaid Accounts Report', x: 500, y: 120, w: 90, h: 90, tone: 'report' },
  { id: 'salesReport', label: 'Customer Sales Report', x: 500, y: 240, w: 90, h: 90, tone: 'report' },
  { id: 'statements', label: 'Customer Statements', x: 500, y: 358, w: 90, h: 90, tone: 'report' },
]

/** Connector polylines; the last point carries the arrowhead. */
export const flowArrows: [number, number][][] = [
  [[45, 120], [45, 45], [250, 45]],
  [[170, 120], [170, 80], [250, 80]],
  [[340, 45], [420, 45], [420, 120]],
  [[90, 165], [120, 165]],
  [[45, 210], [45, 240]],
  [[90, 285], [120, 285]],
  [[220, 165], [370, 165]],
  [[220, 285], [250, 285]],
  [[340, 285], [370, 285]],
  [[295, 330], [295, 358]],
  [[340, 403], [370, 403]],
  [[420, 358], [420, 330]],
]
